import { OnboardingInviteInstitution } from "../components/OnboardingInviteInstitution/OnboardingInviteInstitution";

export function OnboardingInviteInstitutionPage() {
  return (
    <>
      <OnboardingInviteInstitution />
    </>
  );
}

export default OnboardingInviteInstitutionPage;
